import { createContext, useState } from "react"

export const AppContext = createContext()

export const AppContextProvider = ({children}) => {
    const [refresh, setRefresh] = useState(false)

    return (
        <AppContext.Provider value={{refresh, setRefresh}}>{children}</AppContext.Provider>
    )
}